import { webToggles } from '@dustin-web/microsite-config'
import { WebTogglesWithOverrides } from '@dustin-web/microsite-config/src/web-toggles'
import React, { useCallback } from 'react'
import { useOptimizely } from './use-optimizely'

export const WebTogglesContext = React.createContext<WebTogglesWithOverrides>({
  ...webToggles,
  overrides: {},
})

export const useWebToggles = () => {
  const webToggles = React.useContext(WebTogglesContext)

  if (!webToggles) {
    throw new Error('useWebToggles must be used within a WebTogglesContext')
  }

  const { isToggleEnabled: isOptimizelyToggleEnabled } = useOptimizely()

  const isToggleEnabled = useCallback(
    (key: keyof WebTogglesWithOverrides): boolean => {
      if (key === 'overrides') {
        throw new Error('Cannot use `overrides` as a toggle key directly')
      }

      if (webToggles.overrides && webToggles.overrides[key]) {
        return webToggles.overrides[key]?.toLocaleLowerCase() === 'true' ? true : false
      }

      return !!(isOptimizelyToggleEnabled(key) ?? webToggles[key])
    },

    [webToggles, isOptimizelyToggleEnabled]
  )

  return {
    isToggleEnabled,
    toggles: {
      ...webToggles,
    },
  }
}
